import { render, staticRenderFns } from "./TableFulfilledRequests.vue?vue&type=template&id=226daa08"
import script from "./TableFulfilledRequests.vue?vue&type=script&lang=js"
export * from "./TableFulfilledRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports